<template>
  <div class="nps" v-show="isShow" @click="handleClose">
    <div class="nps-main-box" @click.stop>
      <div class="logo-box">
        <img src="https://files.wondercv.com/pc/nps/nps-logo.png"/>
        <div class="logo-text-box">满意度小调查</div>
      </div>
      <p class="title">你愿意推荐好友使用超级简历吗？</p>
      <div class="flex-tag">
        <p><i class="iconfont iconbumanyi"></i>非常不愿意</p>
        <p><i class="iconfont iconmanyi"></i>非常愿意</p>
      </div>
      <div class="score-box">
        <div class="num-item" v-for="(item, index) in 11" :key="item" :class="{active: index === chooseIndex}" @click.stop="handleChooseGrade(index)">
          {{index}}
        </div>
      </div>
      <div v-if="chooseIndex != -1" class="text-box">
        <p>{{chooseIndex <= 6 ? '是我们没做好，请吐槽，让我们做得更好' : (chooseIndex > 6 &&chooseIndex <= 8 ? '感谢认可！您认为我们需要哪些改进' : '感谢认可！您希望有什么新功能吗？')}}</p>
        <textarea id="textarea" placeholder="请输入" v-model="suggestion" ></textarea>
        <div class="sub-btn" @click.stop="handleSubmit">
          提交
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script>
import { componentsMixin } from "@/assets/js/mixin/components";
import { envMixin } from "@/assets/js/mixin/global";
import nps from "@/api/api-list/nps";
import Cookies from "js-cookie";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    token: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      arr: [
        {
          key: 0,
          active: true
        },
        {
          key: 1,
          active: false
        },
        {
          key: 2,
          active: false
        },
        {
          key: 3,
          active: false
        },
        {
          key: 4,
          active: false
        },
        {
          key: 5,
          active: false
        },
        {
          key: 6,
          active: false
        },
        {
          key: 7,
          active: false
        },
        {
          key: 8,
          active: false
        },
        {
          key: 9,
          active: false
        },
        {
          key: 10,
          active: false
        }
      ],
      chooseIndex: -1,
      suggestion: "",
      user_id: "",
      is_fill: 1
    };
  },
  mixins: [componentsMixin, envMixin],
  created() {
    //
    // console.log(ua, ua);
  },

  methods: {
    handleChooseGrade(index) {
      this.chooseIndex = index;
      this.arr.map(item => {
        item.active = false;
      });
      this.arr.splice(index, 1, { key: index, active: true });
      // this.submitNps();
    },
    handleClickCopy() {
      let url = "https://www.wondercv.com/account/users/HXuqxj4/invite";
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.showToast("已复制到剪切板");
      oInput.remove();
    },
    handleSubmit() {
      this.is_fill = true;
      this.submitNps();
      this.$emit("showNps");
    },
    handleClose() {
      this.is_fill = 0;
      this.submitNps();
      this.$emit("showNps");
    },
    submitNps() {
      // user_id
      let _t = Cookies.get("_t");
      if (_t) {
        let tokenPayload = _t && JSON.parse(window.atob(_t.split(".")[1]));
        this.user_id = tokenPayload.User.c_t;
      }
      this.$api.nps
        .addNps({
          score: this.chooseIndex == -1 ? 0 : this.chooseIndex,
          channel: this.isWxMini ? 3 : this.isIos ? 2 : 4,
          comment: this.suggestion,
          label: 0,
          resume_token: this.token,
          user_id: this.user_id,
          is_fill: this.is_fill ? 1 : 0
        })
        .then(res => {
          if (res.code == 1000) {
            if (this.is_fill == 1) {
              this.showToast("提交成功，感谢您的评价！");
            }
          } else {
            this.showToast(res.message);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/global/mixin";
.nps {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  .nps-main-box{
    position: absolute;
    bottom: 0;
    background: #FFFFFF;
    border-radius: 16px 16px 0px 0px;
    padding: 30px 24px 22px 24px;
    width: 375px;
    .logo-box{
      position: absolute;
      display: flex;
      top: -44px;
      img{
        width: 59px;
        height: 44px;
      }
      .logo-text-box{
        width: 96px;
        height: 24px;
        background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
        border-radius: 12px;
        margin-left: 4px;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 12px;
      }
    }
    .title{
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #404040;
      line-height: 22px;
      margin-bottom: 30px;
    }
    .flex-tag{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 17px;
      margin-bottom: 10px;
      p{
        display: flex;
        align-items: center;
        i {
          margin-right: 4px;
          font-size: 12px;
        }
      }
    }
    .score-box{
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      .num-item{
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid rgba(255, 102, 68, 0.3);
        color: #FF6644;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
        &.active{
          background: #FF6644;
          color: #FFF;
        }
      }
    }
    .text-box{
      margin-top: 12px;
      & > p{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #404040;
        line-height: 20px;
        margin-bottom: 8px;
      }
      #textarea{
        width: 100%;
        height: 100px;
        background: #F9F9F9;
        border-radius: 6px;
        border: 1px solid #ECECEC;
        resize: none;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 16px;
      }
      .sub-btn{
        height: 44px;
        background: #FF6644;
        border-radius: 6px;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
        color: #fff;
      }
    }
  }
}
</style>
